<template>
  <b-modal
    id="transit-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer un transit"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
    :hide-footer="!canBeDeleted"
  >
    <div v-if="selectedTransit !== null">
      <div v-if="canBeDeleted">
        Supprimer le transit "{{selectedTransit.name}}" ?
      </div>
      <div v-else>
        Le transit "{{selectedTransit.name}}" ne peut pas être supprimé car il est associé à un ou plusieurs états quotidiens.
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'TransitDeleteModal',

  props: {
    selectedTransit: Object
  },

  computed: {
    canBeDeleted() {
      if (this.selectedTransit === null) {
        return false
      }
      return this.selectedTransit.dailyTransitsCount === 0
    }
  },

  emits: ['didDeleteTransit'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {

      let transitName = this.selectedTransit.name

      api
        .delete(`/transit/${this.selectedTransit.id}`)
        .then(response => {
          this.$emit('didDeleteTransit')
          this.hideModal()
          this.successToast(`Transit \"${transitName}\" supprimé`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('transit-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/transit/TransitDeleteModal.vue